import { create } from "zustand";

const useUIStore = create((set) => ({
	isLoginModalVisible: false,
	isRegisterModalVisible: false,
	isResetModalVisible: false,
	isAuthLoading: false,

	setAuthLoading: (value) => set({ isAuthLoading: value }),

	showLoginModal: () => set({ isLoginModalVisible: true }),
	hideLoginModal: () => set({ isLoginModalVisible: false }),

	showRegisterModal: () => set({ isRegisterModalVisible: true }),
	hideRegisterModal: () => set({ isRegisterModalVisible: false }),

	showResetModal: () => set({ isResetModalVisible: true }),
	hideResetModal: () => set({ isResetModalVisible: false }),

	switchToRegister: () =>
		set({ isLoginModalVisible: false, isRegisterModalVisible: true }),
	switchToLogin: () =>
		set({ isLoginModalVisible: true, isRegisterModalVisible: false }),
	switchToReset: () =>
		set({ isLoginModalVisible: false, isResetModalVisible: true }),
	switchToLoginFromReset: () =>
		set({ isResetModalVisible: false, isLoginModalVisible: true }),
}));

export default useUIStore;
